import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import { IFaqData } from "../../types/api/faqApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { ISubFaq } from "../../types/features/multiLanguageSlice";

const FaqSection: React.FC<{ faq_data: Array<IFaqData> }> = ({ faq_data }) => {
    const {t} = useTranslation()
    const faq_json = t('faq.faqs', { returnObjects: true })  as ISubFaq[];

    return (
        <div>
            <div>
                <section className='faq-section'>
                    <div className="container">
                        <div className="faq-content">
                            <Accordion defaultActiveKey="0">
                                {faq_json && faq_json.length > 0 ?
                                    faq_json.map((faq: ISubFaq, index: number) => (
                                        <Accordion.Item eventKey={"'" + index + "'"}>
                                            <Accordion.Header>{faq.question}</Accordion.Header>
                                            <Accordion.Body>
                                                {faq.answer}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))
                                    : <NoData message="Oops, No FAQ Data Found!!" />
                                }
                            </Accordion>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default FaqSection;